import { jsx } from 'react/jsx-runtime';
import { IconBase } from '../../icon-base/index.js';

const Minus = (props) => (jsx(IconBase, Object.assign({}, props, { svgContent: jsx("path", { d: "M18.25,11.41h-15V10.29h15Z" }), iconName: "minus", viewBox: "0 0 21.6 21.6" })));
Minus.displayName = 'VDS_Icon';

export { Minus as default };
